(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initIemaxeiCollection = (section) => {
      if (!section || section.dataset.iemaxeiInitialized === 'true') return;
      section.dataset.iemaxeiInitialized = 'true';

      /* ========================= FILTER MODAL ========================= */
      const modal = section.querySelector('[data-iemaxei-filter-modal]');
      const dialog = section.querySelector('.iemaxei-filter-dialog');
      const openButtons = section.querySelectorAll('[data-iemaxei-open-filter]');
      const closeButtons = section.querySelectorAll('[data-iemaxei-close-filter]');
      const tabs = section.querySelectorAll('[data-filter-tab]');
      const panels = section.querySelectorAll('[data-filter-panel]');
      const toolbar = section.querySelector('[data-iemaxei-toolbar]');
      const floatingButton = section.querySelector('[data-iemaxei-floating-filter]');
      const pagination = section.querySelector('.iemaxei-pagination');

      let previousFilterFocus = null;

      if (modal && dialog) {
        const activateTab = (index) => {
          const wantedIndex = String(index ?? 0);
          let matched = false;

          tabs.forEach((tab) => {
            const active = tab.dataset.filterTab === wantedIndex;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', active ? 'true' : 'false');
            tab.setAttribute('tabindex', active ? '0' : '-1');

            if (active) {
              matched = true;
              requestAnimationFrame(() => {
                tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
              });
            }
          });

          panels.forEach((panel) => {
            panel.hidden = panel.dataset.filterPanel !== wantedIndex;
          });

          if (!matched && tabs.length) {
            activateTab(tabs[0].dataset.filterTab);
          }
        };

        const openFilterModal = (index, trigger) => {
          previousFilterFocus = trigger || document.activeElement;
          activateTab(index);
          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add('iemaxei-filter-lock');

          const close = dialog.querySelector('[data-iemaxei-close-filter]');
          window.setTimeout(() => close && close.focus(), 30);
        };

        const closeFilterModal = () => {
          modal.classList.remove('is-open');
          modal.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove('iemaxei-filter-lock');

          if (previousFilterFocus && typeof previousFilterFocus.focus === 'function') {
            window.setTimeout(() => previousFilterFocus.focus(), 30);
          }
        };

        openButtons.forEach((button) => {
          button.addEventListener('click', () => {
            openFilterModal(button.dataset.filterIndex || '0', button);
          });
        });

        closeButtons.forEach((button) => {
          button.addEventListener('click', closeFilterModal);
        });

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => activateTab(tab.dataset.filterTab));
        });

        dialog.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            event.preventDefault();
            closeFilterModal();
            return;
          }

          if (event.key !== 'Tab') return;

          const focusables = [...dialog.querySelectorAll(
            'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
          )].filter((el) => el.offsetParent !== null);

          if (!focusables.length) return;

          const first = focusables[0];
          const last = focusables[focusables.length - 1];

          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        });

        const updateFloatingButton = () => {
          if (!floatingButton || !toolbar) return;

          const toolbarRect = toolbar.getBoundingClientRect();
          const paginationRect = pagination ? pagination.getBoundingClientRect() : null;

          const toolbarPassed = toolbarRect.bottom < 0;
          const paginationReached = paginationRect
            ? paginationRect.top < window.innerHeight * 0.78
            : false;

          floatingButton.classList.toggle(
            'is-visible',
            toolbarPassed && !paginationReached && !modal.classList.contains('is-open')
          );
        };

        window.addEventListener('scroll', updateFloatingButton, { passive: true });
        window.addEventListener('resize', updateFloatingButton);
        modal.addEventListener('transitionend', updateFloatingButton);

        const modalObserver = new MutationObserver(updateFloatingButton);
        modalObserver.observe(modal, { attributes: true, attributeFilter: ['class'] });

        updateFloatingButton();

        if (tabs.length) activateTab(tabs[0].dataset.filterTab);
      }

      /* ========================= QUICK VIEW ========================= */
      const quickView = section.querySelector('[data-iemaxei-quickview]');
      const quickViewDrawer = quickView?.querySelector('.iemaxei-quickview-drawer');
      const quickViewContent = quickView?.querySelector('[data-iemaxei-quickview-content]');
      const quickViewOpenButtons = section.querySelectorAll('[data-iemaxei-quickview-open]');
      const quickViewCloseButtons = quickView?.querySelectorAll('[data-iemaxei-quickview-close]') || [];

      let previousQuickViewFocus = null;
      let galleryCleanup = null;

      const initQuickViewGallery = () => {
        if (galleryCleanup) {
          galleryCleanup();
          galleryCleanup = null;
        }

        const track = quickViewContent?.querySelector('[data-quickview-track]');
        const progress = quickViewContent?.querySelector('[data-quickview-progress]');
        if (!track) return;

        let isDragging = false;
        let startX = 0;
        let startScrollLeft = 0;
        let moved = false;

        const updateProgress = () => {
          if (!progress) return;

          const maxScroll = Math.max(1, track.scrollWidth - track.clientWidth);
          const ratio = Math.min(1, Math.max(0, track.scrollLeft / maxScroll));
          const progressTrack = progress.parentElement;
          const thumbWidth = progress.offsetWidth;
          const available = Math.max(0, progressTrack.clientWidth - thumbWidth);

          progress.style.transform = `translateX(${ratio * available}px)`;
        };

        const pointerDown = (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;

          isDragging = true;
          moved = false;
          startX = event.clientX;
          startScrollLeft = track.scrollLeft;
          track.classList.add('is-dragging');
          track.setPointerCapture?.(event.pointerId);
        };

        const pointerMove = (event) => {
          if (!isDragging) return;

          const delta = event.clientX - startX;
          if (Math.abs(delta) > 3) moved = true;
          track.scrollLeft = startScrollLeft - delta;
        };

        const pointerUp = (event) => {
          if (!isDragging) return;

          isDragging = false;
          track.classList.remove('is-dragging');

          try {
            track.releasePointerCapture?.(event.pointerId);
          } catch (error) {}

          if (moved) {
            const slide = track.querySelector('.iemaxei-quickview-slide');
            if (slide) {
              const slideWidth = slide.getBoundingClientRect().width;
              const target = Math.round(track.scrollLeft / slideWidth) * slideWidth;
              track.scrollTo({ left: target, behavior: 'smooth' });
            }
          }
        };

        const preventDraggedClick = (event) => {
          if (moved) {
            event.preventDefault();
            event.stopPropagation();
          }
        };

        track.addEventListener('pointerdown', pointerDown);
        track.addEventListener('pointermove', pointerMove);
        track.addEventListener('pointerup', pointerUp);
        track.addEventListener('pointercancel', pointerUp);
        track.addEventListener('click', preventDraggedClick, true);
        track.addEventListener('scroll', updateProgress, { passive: true });
        window.addEventListener('resize', updateProgress);

        requestAnimationFrame(updateProgress);

        galleryCleanup = () => {
          track.removeEventListener('pointerdown', pointerDown);
          track.removeEventListener('pointermove', pointerMove);
          track.removeEventListener('pointerup', pointerUp);
          track.removeEventListener('pointercancel', pointerUp);
          track.removeEventListener('click', preventDraggedClick, true);
          track.removeEventListener('scroll', updateProgress);
          window.removeEventListener('resize', updateProgress);
        };
      };

      const openQuickView = (button) => {
        if (!quickView || !quickViewContent) return;

        const templateId = button.dataset.templateId;
        const template = templateId ? document.getElementById(templateId) : null;
        if (!template) return;

        previousQuickViewFocus = button;
        quickViewContent.replaceChildren(template.content.cloneNode(true));

        quickView.classList.add('is-open');
        quickView.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('iemaxei-quickview-lock');

        initQuickViewGallery();

        const close = quickView.querySelector('.iemaxei-quickview-close');
        window.setTimeout(() => close && close.focus(), 40);
      };

      const closeQuickView = () => {
        if (!quickView || !quickViewContent) return;

        quickView.classList.remove('is-open');
        quickView.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('iemaxei-quickview-lock');

        window.setTimeout(() => {
          quickViewContent.replaceChildren();

          if (galleryCleanup) {
            galleryCleanup();
            galleryCleanup = null;
          }
        }, 380);

        if (previousQuickViewFocus && typeof previousQuickViewFocus.focus === 'function') {
          window.setTimeout(() => previousQuickViewFocus.focus(), 40);
        }
      };

      quickViewOpenButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          openQuickView(button);
        });
      });

      quickViewCloseButtons.forEach((button) => {
        button.addEventListener('click', closeQuickView);
      });

      quickViewDrawer?.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeQuickView();
          return;
        }

        if (event.key !== 'Tab') return;

        const focusables = [...quickViewDrawer.querySelectorAll(
          'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )].filter((el) => el.offsetParent !== null);

        if (!focusables.length) return;

        const first = focusables[0];
        const last = focusables[focusables.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    };

    const boot = () => {
      document.querySelectorAll('[data-iemaxei-section]').forEach(initIemaxeiCollection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.matches?.('[data-iemaxei-section]')
        ? event.target
        : event.target.querySelector?.('[data-iemaxei-section]');

      if (section) {
        section.dataset.iemaxeiInitialized = 'false';
        initIemaxeiCollection(section);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
